<template>
  <div class="getPhotoHolder fCol jStart aStart"
    v-bind:style="{minWidth: `${w}`}">
    <input type="file" id="getPhotoInput" name="getPhoto"
    ref="file" @change="handleFileUpload($event)"
    accept="image/x-png, image/jpg, image/jpeg, application/msword, .docx, .svg">
    <div class="getPhoto fRow jStart aCenter" v-bind:class="{disable: uploading}"
     v-if="!this.firstUpload" @click="selectPhoto">
      <div class="btnEffect"></div>
      <i class="material-icons-round">add_a_photo</i>
      <div class="fRow jStart aCenter" style="pointer-events: none;">
        <div class="label">{{uploadLabel}}</div>
        <div class="tips">{{uploadMsg}}</div>
      </div>
    </div>
    <div class="imgHolder" v-if="uploaded.length > 0"
      v-bind:class="{disable: uploading}">
      <img @click="selectPhoto" class="preview" :src="`${this.uploaded}`">
      <i class="material-icons-round reloadImage fRow aCenter jCenter"
       title="انتخاب تصویر جایگزین" @click="selectPhoto">loop</i>
      <i class="material-icons-round reloadImage removeImage fRow aCenter jCenter"
       title="حذف" @click="removeImage">delete</i>
    </div>
    <div class="fullWidth fCol jStart aStart" v-if="false">
      <div class="tipItem" v-for="item in tipsss" v-bind:key="item">{{item}}</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import { EventBus } from '@/plugins/event-bus';

export default {
  mixins: [makeToast, errorHandler],
  data() {
    return {
      tipsss: [
        'فقط پسوند‌های JPG، JPEG و PNG مورد قبول هستند.',
        'عکس شما باید در قالب مربع باشد. (طول و عرض برابر باشد)',
        'حداکثر حجم مجاز 300KB، اندازه پیشنهادی 256×256 پیکسل',
      ],
      file: [],
      defImg: `${this.$store.state.baseUrl}/photo/ni.svg`,
      uploaded: '',
      isPhotoSelected: false,
      firstUpload: false,
      uploading: false,
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
    };
  },
  props: ['w', 'uploadLabel', 'uploadMsg', 'photoFor', 'initImg'],
  methods: {
    selectPhoto() {
      // console.log('this.selectPhoto');
      this.$refs.file.click();
    },
    handleFileUpload(event) {
      [this.file] = [this.$refs.file.files[0]];
      let isSquare = false;
      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.onload = () => {
          if (img.width === img.height) {
            isSquare = true;
          }
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
      const fileSize = this.file.size < 3072000;
      const fileType = this.file.type === 'image/jpeg'
        || this.file.type === 'image/png'
        || this.file.type === '.docx'
        || this.file.type === 'application/msword';
      if (fileSize && fileType) {
        this.submitFile();
        return;
      }
      if (!fileSize) {
        this.makeToast('warning', 'حجم فایل بیش از حد مجاز است', 3000);
      } else if (!fileType) {
        this.makeToast('warning', 'پسوند فایل مورد تأیید نیست', 3000);
      } else if (!isSquare) {
        this.makeToast('warning', 'تصویر مربع نیست', 3000);
      }
      // console.log(this.file);
    },
    submitFile() {
      const formData = new FormData();
      formData.append('files', this.file);
      this.uploading = true;
      axios({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: this.$authObeject.authToken(),
        },
        url: `${this.baseURL}/api/v${this.V}/Uploads/photo`,
        data: formData,
      }).then((response) => {
        this.uploading = false;
        if (response.data.isSuccess) {
          this.uploaded = `${this.$store.state.baseUrl}/${response.data.data}`;
          // console.log(response.data.data.split('.').pop());
          this.$emit('photoupload', response.data.data);
          this.firstUpload = true;
          this.makeToast('info', 'تصویر آپلود شد', 2000);
        } else {
          this.makeToast('info', 'خطا در آپلود تصویر', 2000);
          this.responseFalse = true;
        }
      }, (error) => {
        this.uploading = false;
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    init() {
      if (this.initImg === 'none' || this.initImg === undefined || this.initImg === '') {
        this.firstUpload = false;
      } else {
        this.firstUpload = true;
        this.uploaded = `${this.$store.state.baseUrl}/${this.initImg}`;
      }
    },
    removeImage() {
      this.firstUpload = false;
      this.uploaded = '';
      this.$emit('photoupload', '');
    },
  },
  watch: {
    initImg() {
      this.init();
    },
  },
  mounted() {
    // this.uploaded = this.defImg;
    this.init();
    EventBus.$on('clearPhoto', () => {
      this.removeImage();
    });
  },
};
</script>

<style lang='scss' scoped>
.imgHolder{
  position: relative;
}

.reloadImage {
  position: absolute;
  top: 8px;
  right: 8px;
  border-radius: 80px;
  font-size: 16px;
  color: #525252;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 8px 8px rgba(0, 0, 0, 0.24);
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.reloadImage.removeImage {
  top: 40px;
  color: #ffffff;
  background-color: rgb(182, 0, 0);
}

.getPhotoHolder{
  margin-bottom: 16px;
}
.getPhoto{
  border-radius: 64px;
  padding: 4px 8px;
  background-color: rgba($color: #000000, $alpha: 0.07);
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: all cubic-bezier(0.5, 0, 0, 0.5) 0.2s;
}

.getPhoto.disable{
  pointer-events: none;
  opacity: 0.2;
}

.getPhoto .btnEffect{
    position: absolute;
    right: 18px;
    top: 50%;
    width: 0px;
    height: 0px;
    pointer-events: none;
    transform: translate(50%, -50%);
    border-radius: 50%;
    border: solid 0px rgba(255, 255, 255, 0.123);
    background-color: rgba(0, 0, 0, 0.096);
    transition: all cubic-bezier(0.5, 0, 0, 1) 0.8s;
    z-index: 10;
}

.getPhoto:hover .btnEffect{
    width: 512px;
    height: 512px;
    border: solid 64px rgba(255, 255, 255, 0);
}

.getPhoto:active .btnEffect{
    width:  64px;
    height: 64px;
    border: solid 8px rgba(255, 255, 255, 0);
}

.getPhoto i{
  font-size: 16px;
  pointer-events: none;
  color: rgb(104, 104, 104);
  padding-left: 16px;
  margin-left: 16px;
  border-left: dashed 2px rgba($color: #000000, $alpha: 0.2);
}

#getPhotoInput{
  display: none;
}

.label{
  font-size: 14px;
  font-weight: bold;
  color: rgb(41, 41, 41);
  text-align: right;
  z-index: 20;
}

.tips{
  font-size: 12px;
  font-weight: 200;
  color: rgb(109, 109, 109);
  text-align: right;
  margin-right: 8px;
  z-index: 20;
}

.tipItem{
  font-size: 10px;
  font-weight: 200;
  text-align: right;
  position: relative;
  margin: 8px 0 0 0;
  padding-right: 16px;
}

.tipItem::after{
  position: absolute;
  content: ' ';
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
  border-radius: 80px;
  width: 8px;
  height: 8px;
  background-color: rgba($color: #000000, $alpha: 0.2);
}

$previewSize: 112px;
.preview {
  max-height: $previewSize;
  max-width: 500px;
  min-height: 80px;
  border-radius: 4px;
  margin: 0;
  box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.1);
}

</style>
